import { Action, createAction } from 'redux-act';

import AccountActivationResult from '../../../models/interfaces/AccountActivationResult';
import TimestampPayload from '../TimestampPayload';

export interface ActivateAccountPayload {
  token: string;
}
export const activateAccount = createAction<ActivateAccountPayload>('ACTIVATE_ACCOUNT');
export type ActivateAccountActionType = Action<ActivateAccountPayload>;

export interface AccountActivationResultPayload extends TimestampPayload {
  accountActivationResult: AccountActivationResult;
  token: string;
}
export const accountActivationFinished = createAction<AccountActivationResultPayload>('ACCOUNT_ACTIVATION_FINISHED');
export const accountActivationFailed = createAction<AccountActivationResultPayload>('ACCOUNT_ACTIVATION_FAILED');
